import React, { useEffect, useRef, useState } from 'react';
import { Fieldset } from 'primereact/fieldset';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { Toolbar } from 'primereact/toolbar';
import InstrumentService from './instrument-service';
import { useToast } from '../../../components/Toast';
import instrumentService from './instrument-service';
import BreadcrumbComponent from '../../../components/Breadcrumb';
import { QRCodeCanvas } from 'qrcode.react';
import { useDialog } from '../../../components/Dialog';
import { Toast } from 'primereact/toast';

const InstrumentView: React.FC = () => {
  const [clientState, setClientState] = useState<any>(null);
  const navigate = useNavigate();
  const { showToast } = useToast();
  const location = useLocation();
  const selectedItem = location.state?.selectedItem;
  const isEditMode = !!selectedItem;
  const { t } = useTranslation('common');
  const [formData, setFormData] = useState<any>({ insertDate: new Date() });
  const { showConfirmDialog } = useDialog();
  const [printerName, setPrinterName] = useState<string>("");
  const toast = useRef<Toast>(null);

  const defaultData = { insertDate: new Date(), recordStatus: '1' };

  // ✅ Print target
  const printRef = useRef<HTMLDivElement>(null);

  const handlePrint = () => window.print();

  useEffect(() => {
    const fetchClientState = async () => {
      try {
        const clientStateItem = await instrumentService.getClientState();
        setClientState(clientStateItem);

        const result = await instrumentService.getPrinterName("PRINTER_NAME");

        setPrinterName(result.parameterValue);
        if (isEditMode) setFormData(selectedItem);
        else setFormData(defaultData);
      } catch (error: any) {
        if (clientState?.error) {
          clientState.error.detail = error?.response?.data?.message || String(error);
          showToast(clientState.error);
        }
      }
    };
    fetchClientState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderQRCode = (rowData: any) => (
    <div className="flex justify-center p-4">
      <QRCodeCanvas value={rowData?.qrValue} size={180} />
    </div>
  );

  const printQRLabelZPL = async (qrValue: string, printerName: string) => {


    //printer zebra use this
    const zpl = `
            ^XA
            ^PW320
            ^LL236
            ^MD30
            ^FO70,22
            ^BQN,2,6
            ^FDLA,${qrValue}^FS
            ^XZ
            `;


    //printer TSC use this
    // const zpl = `
    //         ^XA
    //         ^FO320,23
    //         ^BQN,2,9
    //         ^FDLA,${qrValue}^FS
    //         ^XZ
    //           `;
    const item = {
      labelCode: zpl,
      printerName: printerName
    };
    // await qrService.print(item);

    const response = await fetch('http://localhost:3006/print', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ labelCode: zpl, printerName }),
    });
  };

  function handleUnassignQRCode(qrId: any): void {
    showConfirmDialog('Confirmation', 'Are you sure you unassigned this?', () => {
      selectedItem.qrdet.instrumentId = null;
      selectedItem.qrdet.assignBy = null;
      selectedItem.qrdet.assignDate = null;
      selectedItem.qrdet.unassignBy = clientState.fullName;
      selectedItem.qrdet.unassignDate = new Date();
      selectedItem.qrdet.snNo = selectedItem.snNo;
      selectedItem.qrdet.userId = clientState.fullName;
      selectedItem.qrdet.facilityCode = clientState.facilityCode;
      InstrumentService.unassignQr(selectedItem.qrdet)
        .then(() => {
          showToast(clientState.success);
          navigate(-1);
        })
        .catch((error: any) => {
          clientState.error.detail = error.response?.data?.message || 'Failed to create record.';
          showToast(clientState.error);
        });
    });
  }

  const toolbarTemplate = () => {
    const handleBack = () => navigate(`/machine/instrument`);
    return (
      <>
        {/* <Button label="Print" icon="pi pi-print"style={{ marginRight: '.5em' }} className="p-button-help" onClick={handlePrint} /> */}
        <Button label={t('back')} icon="pi pi-reply" style={{ marginRight: '.5em' }} onClick={handleBack} />
      </>
    );
  };

  return (
    <div className="grid">
      <div className="col-12">
        <div className="card-title no-print">
          <h5>Instrument View</h5>
          <BreadcrumbComponent />
        </div>

        <div className="form-title">
          {/* ✅ ONLY this section will be printed */}
          <div ref={printRef} className="instrument-print">
            <Fieldset
              legend={
                <>
                  <span className="legend-view">Instrument View</span>
                  <span className="legend-print">Instrument Report</span>
                </>
              }
            >
              <div className="field col-12 flex justify-content-center">
                {selectedItem?.qrdet?.qrValue ? renderQRCode(selectedItem.qrdet) : null}
              </div>

              {selectedItem?.qrdet?.qrId && (
                <div className="field col-12 flex justify-content-center mb-6 no-print">
                  <Button
                    label="Unassign QR Code"
                    className=" p-button-danger p-button-sm mr-2"
                    style={{ minWidth: 100, fontSize: 16 }}
                    onClick={() => handleUnassignQRCode(selectedItem?.instrumentId)}
                  />
                  <Button
                    label="Reprint QR Code"
                    className="p-button-warning p-button-sm "
                    style={{ minWidth: 100, fontSize: 16 }}
                    onClick={async () => {
                      try {
                        await printQRLabelZPL(selectedItem?.qrdet?.qrValue, printerName);
                        toast.current?.show({
                          severity: 'success',
                          summary: 'Printing',
                          detail: 'Printing QR code.',
                        });
                      } catch (err: any) {
                        toast.current?.show({
                          severity: 'error',
                          summary: 'Print Error',
                          detail: 'Printer not found or nova device offline',
                        });
                      }
                    }}
                  />
                </div>
              )}

              <div className="p-fluid form-grid-edit grid">
                <div className="f-view">
                  <label className="f-label">Serial No</label>
                  <div className="f-input">
                    {selectedItem?.snNo || 'N/A'}
                  </div>
                </div>

                <div className="f-view">
                  <label className="f-label">Instrument Code</label>
                  <div className="f-input">
                    {selectedItem?.itemCode || 'N/A'}
                  </div>
                </div>

                <div className="f-view">
                  <label className="f-label">Instrument Name</label>
                  <div className="f-input">
                    {selectedItem?.itemDesc || 'N/A'}
                  </div>
                </div>

                <div className="f-view">
                  <label className="f-label">Installation Location</label>
                  <div className="f-input">
                    {selectedItem?.installationLocation || 'N/A'}
                  </div>
                </div>

                <div className="f-view">
                  <label className="f-label">Manufacturer Name</label>
                  <div className="f-input">
                    {selectedItem?.manufacturerName || 'N/A'}
                  </div>
                </div>

                {selectedItem?.entity !== 'BMSG' && (
                  <div className="f-view">
                    <label className="f-label">Region</label>
                    <div className="f-input">
                      {selectedItem?.regionHasOne?.fullDesc || 'N/A'}
                    </div>
                  </div>
                )}

                <div className="f-view">
                  <label className="f-label">Equipment Type</label>
                  <div className="f-input">
                    {selectedItem?.equipType?.toUpperCase() || 'N/A'}
                  </div>
                </div>

                <div className="f-view">
                  <label className="f-label">Last PM Date</label>
                  <div className="f-input">
                    {selectedItem?.lastPmDate
                      ? new Date(selectedItem.lastPmDate).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                      })
                      : 'N/A'}
                  </div>
                </div>
                <div className="f-view">
                  <label className="f-label">Next PM Date</label>
                  <div className="f-input">
                    {selectedItem?.nextPmDate
                      ? new Date(selectedItem.nextPmDate).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                      })
                      : 'N/A'}
                  </div>
                </div>

                <div className="f-view">
                  <label className="f-label">Installation Date</label>
                  <div className="f-input">
                    {selectedItem?.installDate
                      ? new Date(selectedItem.installDate).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                      })
                      : 'N/A'}
                  </div>
                </div>

                <div className="f-view">
                  <label className="f-label">Warranty End Date</label>
                  <div className="f-input">
                    {selectedItem?.warrantyEndDate
                      ? new Date(selectedItem.warrantyEndDate).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                      })
                      : 'N/A'}
                  </div>
                </div>

                <div className="f-view">
                  <label className="f-label">QR Status</label>
                  <div className="f-input">
                    {selectedItem?.qrdet === null ? 'Unassigned' : 'Assigned'}
                  </div>
                </div>

                <div className="f-view">
                  <label className="f-label">Contract Start Date</label>
                  <div className="f-input">
                    {selectedItem?.contractStartDate
                      ? new Date(selectedItem.contractStartDate).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                      })
                      : 'N/A'}
                  </div>
                </div>

                <div className="f-view">
                  <label className="f-label">Contract End Date</label>
                  <div className="f-input">
                    {selectedItem?.contractEndDate
                      ? new Date(selectedItem.contractEndDate).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                      })
                      : 'N/A'}
                  </div>
                </div>

                <div className="f-view">
                  <label className="f-label">Item Status</label>
                  <div className="f-input">
                    {formData?.status || 'N/A'}
                  </div>
                </div>

              </div>
            </Fieldset>

            {/* Optional: note that only shows in print */}
            <div className="print-note">
              <p><i>This document is generated by system. No signature is required.</i></p>
            </div>
          </div>

          <div style={{ marginTop: '2rem' }} className="no-print">
            <Toolbar end={toolbarTemplate} />
          </div>
        </div>
      </div>

      {/* ✅ Print stylesheet */}
      <style>{`
        /* Default (screen): hide print-only elements */
        .legend-print { display: none; }
        .print-note { display: none; }

        /* Utility to hide elements during print */
        .no-print { display: block; }

        @media print {
          @page {
            size: A4 portrait;
            margin: 16mm;
          }

          /* Hide everything by default */
          body * { visibility: hidden; }

          /* Show only the print block */
          .instrument-print, .instrument-print * {
            visibility: visible;
          }

          /* Position at top-left */
          .instrument-print {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
          }

          /* Keep 3-column layout (PrimeFlex col class has :) */
          .instrument-print .col-12.md\\:col-4 {
            flex: 0 0 auto !important;
            width: 33.3333% !important;
          }

          /* Hide toolbars/buttons in print */
          .no-print, .p-button, .p-toolbar, .card-title { display: none !important; }

          /* Swap legend titles on print */
          .legend-view { display: none !important; }
          .legend-print { display: inline !important; }

          /* Show the note in print */
          .print-note {
            display: block;
            margin-top: 2rem;
            text-align: center;
            font-size: 12px;
            font-style: italic;
          }

          /* Make QR canvas crisp in print */
          .instrument-print canvas {
            image-rendering: pixelated;
          }
        }
      `}</style>
    </div>
  );
};

export default InstrumentView;
